<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="contact"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
          class="flex flex-row w-full"
          autocomplete="off"
        >
          <div class="flex-1">
            <div class="lg:mb-4">
            </div>
            
            <base-collapsible-form v-if="(role === 7 || role === 8 || role === 3 ) && !isIssuingCreation"
              ref="baseCollapsibleGeneral"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('app.general_information')}}</h4>
              </template>
              <template slot="content">
                <div class="flex flex-col lg:flex-row gap-x-6">
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('clients.entity_name')}}</label>
                    <div class="flex justify-between">
                      <el-form-item prop="IdCliente" class="w-full">       
                        <el-select class="w-full" 
                          v-model="form.IdCliente" 
                          clearable 
                          filterable 
                          :placeholder="$t('app.select')"
                          :loading="loadingClientes" 
                          :disabled="!isCreate || isRoleUserConsultaProvider">
                          <el-option
                            v-for="opt in clientes"
                            :key="opt.key"
                            :label="opt.label"
                            :value="opt.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <base-button v-if="!isCreate || isRoleUserConsultaProvider" class="mb-1 ml-4" mode="primary" :text="$t('app.detail')"  @click.prevent.stop="goDetailClient" :loading="isGeneralLoading" type="button" />
                    </div>
                  </div>
                </div>
              </template>
            </base-collapsible-form>
            
            <base-collapsible-form 
              ref="baseCollapsibleTaxIdentification"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('contacto.tax_identification')}}</h4>
              </template>
              <template slot="content">

                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('agenda.PersonTypeCode')}}</label>
                  <el-form-item prop="PersonType">
                    <el-switch 
                      class="switch-text break-normal both-switch" 
                      v-model="form.PersonType" 
                      :disabled="isRoleUserConsultaProvider"
                      :inactive-text="$t('tipos.persona.juridica')"
                      :active-text="$t('tipos.persona.fisica')"
                      inactive-value="J"
                      active-value="F"
                      inactive-color="var(--primary-800)"/>
                  </el-form-item>
                </div>
                
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>
                    {{ isJuridicPerson ? $t('companies.companyName') : $t('app.name') }}
                  </label>
                  <el-form-item prop="NameCorporateName">
                    <el-input
                      clearable
                      :disabled="isRoleUserConsultaProvider"
                      class="w-full"
                      v-model="form.NameCorporateName"
                      maxlength='80'
                    />
                  </el-form-item>
                </div>
                <template v-if="!isJuridicPerson">
                  <div>
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>
                      {{ $t('persons_data.firstsurname') }}
                    </label>
                    <el-form-item prop="FirstSurname">
                      <el-input
                        clearable
                        :disabled="isRoleUserConsultaProvider"
                        class="w-full"
                        v-model="form.FirstSurname"
                        maxlength='40'
                      />
                    </el-form-item>
                  </div>
                  
                  <div>
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">
                      {{ $t('persons_data.secondsurname') }}
                    </label>
                    <el-form-item prop="SecondSurname">
                      <el-input
                        clearable
                        :disabled="isRoleUserConsultaProvider"
                        class="w-full"
                        v-model="form.SecondSurname"
                        maxlength='40'
                      />
                    </el-form-item>
                  </div>
                </template>
 
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ isJuridicPerson ? $t('companies.cif') : $t('agenda.nif_nie') }}</label>
                  <el-form-item prop="TIN">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.TIN"
                      :disabled="isRoleUserConsultaProvider"
                      minlength="3"
                      maxlength='30'
                    />
                  </el-form-item>
                </div>

                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('agenda.ResidenceTypeCode')}}</label>
                  <el-form-item prop="ResidenceType">
                    <el-select class="w-full" 
                      v-model="form.ResidenceType"
                      :disabled="isRoleUserConsultaProvider">
                        <el-option
                          v-for="opt in tiposResidencia"
                          :key="opt.id"
                          :label="opt.name"
                          :value="opt.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
               
                <div v-if="false">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('tipos.pge.autofactura') }}</label>
                  <el-form-item prop="IsSeflInvoiceSociety">
                    <el-switch 
                      class="switch-text break-normal both-switch" 
                      v-model="form.IsSeflInvoiceSociety" 
                      :disabled="isRoleUserConsultaProvider"
                      :active-text="$t('app.yes')"
                      :inactive-text="$t('app.no')"
                    />
                  </el-form-item>
                </div>

                <div v-if="form.IsSeflInvoiceSociety" >
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.self_invoice_email') }}</label>
                  <el-form-item prop="SendEmailSelfInvoice">
                    <el-switch 
                      class="switch-text break-normal both-switch" 
                      v-model="form.SendEmailSelfInvoice" 
                      :disabled="isRoleUserConsultaProvider"
                      :active-text="$t('app.yes')"
                      :inactive-text="$t('app.no')"
                    />
                  </el-form-item>
                </div>

              </template>
            </base-collapsible-form>
            
            <!-- <base-collapsible-form 
              ref="baseCollapsibleEntity"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('contacto.entity')}}</h4>
              </template>
            </base-collapsible-form> -->
            
            <base-collapsible-form v-if="false" ref="baseCollapsibleRegistrationData"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('contacto.RegistrationData')}}</h4>
              </template>
              <template slot="content">
                <div class="flex flex-col md:flex-row items-center gap-x-2">  
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.Book') }}</label>
                    <el-form-item prop="Book">
                      <el-input
                        clearable
                        :disabled="isRoleUserConsultaProvider"
                        class="w-full"
                        v-model="form.Book"
                        maxlength='20'
                      />
                    </el-form-item>
                  </div>
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.RegisterOfCompaniesLocation') }}</label>
                    <el-form-item prop="RegisterOfCompaniesLocation">
                      <el-input
                        clearable
                        :disabled="isRoleUserConsultaProvider"
                        class="w-full"
                        v-model="form.RegisterOfCompaniesLocation"
                        maxlength='20'
                      />
                    </el-form-item>
                  </div>
                </div>
                <div class="flex flex-col md:flex-row items-center gap-x-2">
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.Sheet') }}</label>
                    <el-form-item prop="Sheet">
                      <el-input
                        clearable
                        :disabled="isRoleUserConsultaProvider"
                        class="w-full"
                        v-model="form.Sheet"
                        maxlength='20'
                      />
                    </el-form-item>
                  </div>
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.Folio') }}</label>
                    <el-form-item prop="Folio">
                      <el-input
                        clearable
                        :disabled="isRoleUserConsultaProvider"
                        class="w-full"
                        v-model="form.Folio"
                        maxlength='20'
                      />
                    </el-form-item>
                  </div>
                </div>
                <div class="flex flex-col md:flex-row items-center gap-x-2">
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.Section') }}</label>
                    <el-form-item prop="Section">
                      <el-input
                        clearable
                        :disabled="isRoleUserConsultaProvider"
                        class="w-full"
                        v-model="form.Section"
                        maxlength='20'
                      />
                    </el-form-item>
                  </div>
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.Volume') }}</label>
                    <el-form-item prop="Volume">
                      <el-input
                        clearable
                        :disabled="isRoleUserConsultaProvider"
                        class="w-full"
                        v-model="form.Volume"
                        maxlength='20'
                      />
                    </el-form-item>
                  </div>
                </div>
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('agenda.additional_data') }}</label>
                  <el-form-item prop="AdditionalData">
                    <el-input
                      clearable
                      :disabled="isRoleUserConsultaProvider"
                      class="w-full"
                      v-model="form.AdditionalData"
                      maxlength='20'
                    />
                  </el-form-item>
                </div>
              </template>
            </base-collapsible-form>     
          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="secondary"
            :text="isCreate ? $t('app.cancel') : $t('app.back')"
            icon="cross"
            @click="goBack"
            :loading="isGeneralLoading"
          />
          <base-button-responsive
            v-if="!isRoleUserConsultaProvider"
            mode="primary"
            :text="isSocietyCreation ? $t('app.save_and_continue') : $t('app.save')"
            icon="check"
            @click="submitForm('ruleForm')"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
    </template>
  </detail-layout>
</template>

<script>
import { bus } from '@/main'
import { i18n } from '@/i18n'

import DetailLayout from '@/components/layout/DetailLayout.vue'

import { getClients } from '@/services/clients/getClients'
import { getSociedad } from '@/services/configurations/getSociedad'
import { addSociedad } from '@/services/configurations/addSociedad'
import { updateSociedad } from '@/services/configurations/updateSociedad'
import { getAllCompanies } from '@/services/companies/getAllCompanies'

import { setTransitionAllowed } from '@/services/functions/modeAllowedTransitionHelper'

export default {
  /* eslint-disable camelcase */
  name: 'template-detail',
  components: {
    DetailLayout,
  },
  data: function () {
    return {
      searchView: false,
      activeName: 'es',
      distribuidores: [],
      loadingClientes: false,
      header: {
        title: i18n.t('agenda.sociedad_header'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'masters/society',
        params: { issuingCreation: false }
      },
      loadedFirstTime: false,
      companies: [],
      form: this.getDefaultForm(),
      clientes: [],
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      rules: {
        IdCliente: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        ResidenceTypeCode: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        TIN: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
          {
            required: true,
            message: i18n.t('validation.length_min_number') + i18n.tc('app.n_character', 3),
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!value || value.length < 3) {
                callback(new Error())
              } else {
                callback()
              }
            }
          },
        ],
        NameCorporateName: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        FirstSurname: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
      },
    }
  },
  computed: {
    isRoleProvider: function () {
      return this.role === 9
    },
    isJuridicPerson () {
      return this.form.PersonType === 'J'
    },
    getIdClientLogged: function () {
      return this.$store.getters['auth/user'].idCliente
    },
    isSelectClientEmpty: function () {
      return !this.form.idCliente
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    isIssuingCreation: function () {
      return !!this.$store.getters['app/isInMode'](1)
    },
    issuingType: function () {
      return this.$store.getters['invoicesIssuing/issuingType']
    },
    isSocietyCreation: function () {
      return !!this.$store.getters['app/isInMode'](2)
    },
    id: function () {
      return parseInt(this.$route.params.id)
    },
    isCreate: function () {
      return this.id === -1 || this.id === '-1'
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isClientFilterActive () {
      return this.$store.getters['sociedades/isClientFilterActive']
    },
    actualFilterNav () {
      return this.$store.getters['app/idClienteFilterVNav']
    },
    isRoleUserConsultaProvider: function () {
      return this.role === 1 || this.role === 4 || this.role === 9
    },
    hasAutofactura: function () {
      return !!this.$store.getters['auth/hasAutofacturaModule']
    },
    tiposRolAgenda: function () {
      return this.$store.getters['config/TIPOS_ROL_AGENDA']
    },
    tiposResidencia: function () {
      return this.$store.getters['config/TIPOS_RESIDENCIA']
    },
    listPaises: function () {
      return this.$store.getters['config/PAISES']
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    'form.ResidenceTypeCode': function (value, oldValue) {
      if (value === 'R') {
        this.form.CountryCode = 'ESP'
      } else {
        this.form.CountryCode = null
      }
    },
    'form.idCliente': {
      deep: true,
      handler: 'watchidClienteHandler'
    },
  },
  created: async function () {
    if (this.isCreate) await this.$store.dispatch('app/enterMode', 2)
    if (this.role === 7 || this.role === 8 || this.role === 3) {
      this.loadingClientes = true
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataClients))
      }
      this.clientes = dataClients.Clientes.map(x => ({ label: x.Nombre, key: x.idCliente, value: x.idCliente }))
      this.loadingClientes = false
    } else {
      this.form.idCliente = this.getIdClientLogged
    }
    const breadcrumbs = []

    if (this.isIssuingCreation) {
      this.header.url = 'invoicesissuing'
      this.header.params.issuingCreation = true
      this.header.params.issuingType = this.issuingType
      const issuingBreadcrumb = {
        path: 'invoicesissuing',
        name: i18n.t('invoices.invoices_issuing.header_long'),
        params: { issuingCreation: true, issuingType: this.issuingType }
      }
      if (this.issuingType === 2) issuingBreadcrumb.name = i18n.t('invoices.invoices_issuing.proforma.header_long')
      else if (this.issuingType === 3) issuingBreadcrumb.name = i18n.t('invoices.invoices_issuing.quotation.header_long')
      breadcrumbs.push(issuingBreadcrumb)
    } else if (this.isRoleProvider) {
      breadcrumbs.push({
        path: 'masters',
        name: i18n.t('companies.header')
      })
    } else {
      breadcrumbs.push({
        path: 'masters',
        name: i18n.t('masters.header')
      })
      breadcrumbs.push({ path: 'masters/society', name: i18n.t('agenda.sociedad') })
    }

    if (!this.isCreate || !this.isSocietyCreation) {
      await this.downloadData(this.id)
      const cabecera = this.form.NameCorporateName + ' ' + (this.form.FirstSurname || '')
      breadcrumbs.push({ path: '', name: cabecera })
      this.$store.commit('app/setheaderBreadCrumb', cabecera,)
      this.disableRoutes(this.form)
    } else {
      if (this.isIssuingCreation) {
        this.form.IdCliente = this.$route.params.IdCliente
      } else if (this.actualFilterNav && this.isClientFilterActive) {
        this.form.IdCliente = this.actualFilterNav.idCliente 
      }
      breadcrumbs.push({
        path: '',
        name: i18n.t('agenda.new_sociedad')
      })
    }
    this.header.breadcrumb = breadcrumbs
  },
  mounted () {
    if (this.$refs.baseCollapsibleGeneral) {
      this.$refs.baseCollapsibleGeneral.toggle()
    }
    this.$refs.baseCollapsibleTaxIdentification.toggle()
    // this.$refs.baseCollapsibleEntity.toggle()
  },
  methods: {
    disableRoutes: function (contact) {
      const objDisableRoutes = {
        disableSedes: this.isRoleProvider,
        disableUserProvider: this.isRoleUserConsultaProvider || !contact.IsSeflInvoiceSociety,
        disableLinkedCompanies: this.isRoleProvider
      }
      bus.$emit('disableOptionsContact', objDisableRoutes)
    },
    watchidClienteHandler: async function () {
      this.form.idCIFEmpresa = null
      this.companies = []
      if (this.role !== 9) {
        if (this.form.idCliente) {
          const data = await getAllCompanies({ idCliente: this.form.idCliente })
          if (data.blnError === true) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
          } else {
            data.CIFSEmpresa.forEach(row => {
              this.companies.push({ value: row.IdCIFEmpresa, label: row.CIF + ' - ' + row.RazonSocial })
            })
          }
        }
      }
    },
    getDefaultForm: function () {
      return {
        IdCliente: null,
        Cliente: '',
        AgendaGeneral: null,
        TIN: '',
        ResidenceType: 'R',
        PersonType: 'J',
        NameCorporateName: '',
        FirstSurname: '',
        SecondSurname: '',
        Book: '',
        RegisterOfCompaniesLocation: '',
        Sheet: '',
        Folio: '',
        Section: '',
        Volume: '',
        AdditionalData: '',
        SendEmailSelfInvoice: false,
        IsSeflInvoiceSociety: false,
      }
    },
    goDetailClient () {
      this.$router.push({ name: 'configurations/clients/details', params: { id: parseInt(this.form.IdCliente) } })
    },
    watchFormHandler: function ({
      certificate,
      send_alerts
    }) {},
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    submitForm: function (formName) {
      if (this.isCreate) {
        this.newContactHandler(formName)
      } else {
        this.updateContactHandler(formName)
      }
    },
    newContactHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const params = {
            IdCliente: this.isIssuingCreation ? this.$route.params.IdCliente : this.form.IdCliente,
            IsSeflInvoiceSociety: this.form.IsSeflInvoiceSociety,
            TIN: this.form.TIN,
            ResidenceType: this.form.ResidenceType,
            PersonType: this.form.PersonType,
            NameCorporateName: this.form.NameCorporateName,
            FirstSurname: this.form.FirstSurname,
            SecondSurname: this.form.SecondSurname,
            RegistrationData: {
              Book: this.form.Book,
              RegisterOfCompaniesLocation: this.form.RegisterOfCompaniesLocation,
              Sheet: this.form.Sheet,
              Folio: this.form.Folio,
              Section: this.form.Section,
              Volume: this.form.Volume,
              AdditionalData: this.form.AdditionalData,
            },
            SendEmailSelfInvoice: this.form.SendEmailSelfInvoice,
          }
          const response = await addSociedad(params)
          if (response.blnError === true) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          } else {
            this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
            this.resetForm()
            this.goBack(response.Respuesta)
            this.form = this.getDefaultForm()
            if (this.role !== 7 && this.role !== 8 && this.role !== 3) {
              this.form.IdCliente = this.getIdClientLogged
            }
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    updateContactHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const params = {
            IdSociedad: this.id,
            AgendaGeneral: this.form.AgendaGeneral || false,
            IsSeflInvoiceSociety: this.form.IsSeflInvoiceSociety,
            IdCliente: this.form.IdCliente,
            TIN: this.form.TIN,
            ResidenceType: this.form.ResidenceType,
            PersonType: this.form.PersonType,
            NameCorporateName: this.form.NameCorporateName,
            FirstSurname: this.form.FirstSurname,
            SecondSurname: this.form.SecondSurname,
            RegistrationData: {
              Book: this.form.Book,
              RegisterOfCompaniesLocation: this.form.RegisterOfCompaniesLocation,
              Sheet: this.form.Sheet,
              Folio: this.form.Folio,
              Section: this.form.Section,
              Volume: this.form.Volume,
              AdditionalData: this.form.AdditionalData,
            },
            SendEmailSelfInvoice: this.form.SendEmailSelfInvoice,
          }
          const response = await updateSociedad(params)
          if (response.blnError === false) {
            this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
            this.updateView()
            this.goBack()
          } else {
            this.doFeedback(response.msgError)
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    goBack: function (idSociedad = -1) {
      if (typeof idSociedad === 'number' && idSociedad !== -1) {
        if (this.isSocietyCreation) {
          this.goCreateSede(idSociedad)
        } else {
          this.$router.push({ name: 'masters/society' })
        }
      } else if (this.isIssuingCreation) {
        this.goEmission()
      } else {
        this.$router.push({ name: 'masters/society' })
      }
    },
    downloadData: async function (id) {
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idSociedad: id
        }
        const res = await getSociedad(params)
        this.setContact(res.respuesta)
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    setContact: function (contact) {
      this.form.IdCliente = contact.IdCliente
      this.form.IsSeflInvoiceSociety = contact.IsSeflInvoiceSociety
      this.form.TIN = contact.TIN
      this.form.ResidenceType = contact.ResidenceType
      this.form.PersonType = contact.PersonType
      this.form.NameCorporateName = contact.NameCorporateName
      this.form.FirstSurname = contact.FirstSurname
      this.form.SecondSurname = contact.SecondSurname
      this.form.Book = contact.RegistrationData?.Book
      this.form.RegisterOfCompaniesLocation = contact.RegistrationData?.RegisterOfCompaniesLocation
      this.form.Sheet = contact.RegistrationData?.Sheet
      this.form.Folio = contact.RegistrationData?.Folio
      this.form.Section = contact.RegistrationData?.Section
      this.form.Volume = contact.RegistrationData?.Volume
      this.form.AdditionalData = contact.RegistrationData?.AdditionalData
      this.form.SendEmailSelfInvoice = contact.SendEmailSelfInvoice
    },
    updateView: function () {
      const cabecera = this.form.NameCorporateName + ' ' + (this.form.FirstSurname || '')
      this.header.breadcrumb[2].name = cabecera
      this.$store.commit('app/setheaderBreadCrumb', cabecera)
    },
    goEmission () {
      setTransitionAllowed(1, true)
      this.$router.push({ name: 'invoicesissuing', params: { issuingType: this.issuingType } })
    },
    goCreateSede (idSociedad = -1) {
      setTransitionAllowed(1, this.isIssuingCreation)
      setTransitionAllowed(2, true)
      this.$router.push({ 
        name: 'masters/society/locations/details',
        params: { id: idSociedad, idSede: -1 }
      })
    },
  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
</style>

<style lang="sass" scoped>
</style>
